import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/assets/settings/easm-settings')({
  beforeLoad: () => getTitleContextSlice('EASM Settings'),
});
